import { useInfiniteQuery } from 'react-query';
import { toast } from 'react-toastify';
import client from 'client';

export default (conversationtId) => {
  const fetchInboxMessages = ({ pageParam = 1, queryKey }) => {
    const method = queryKey[0];
    const url = queryKey[1];
    const params = queryKey[2];
    return client.request({
      method,
      url,
      params: { ...params, page: pageParam },
    });
  };

  const reopenConversation = async () => {
    try {
      await client.put(`/apis/v2/conversations/${conversationtId}/reactivate_conversation`, {});
      window.location.reload();
    } catch (err) {
      toast.error(() => err.message);
    }
  };

  const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage, isSuccess } = useInfiniteQuery(['GET', '/apis/v2/messages/inactive', { per: 10 }], fetchInboxMessages, {
    getNextPageParam: (lastPage) => {
      if (!lastPage.data) {
        return 1;
      }
      if (lastPage.data.meta.page === lastPage.data.meta.totalPages) {
        return undefined;
      }
      if (lastPage.data) {
        return lastPage.data.meta.page + 1;
      }
      return 1;
    },
    // eslint-disable-next-line no-unsafe-optional-chaining
    getPreviousPageParam: (firstPage) => firstPage.data?.meta?.page - 1 || 1,
  });
  const joinedArrays = (data?.pages?.map((page) => page.data?.data).flat(1) || []).filter((n) => n);
  return { data: joinedArrays, isLoading, fetchNextPage, hasNextPage, isFetching: isLoading, isFetchingNextPage, total: joinedArrays.length, isSuccess, reopenConversation };
};
